import type { FilterDefinition, FilterHandler } from '../engine/types';
import {
  FilterId,
  FilterType,
  type MultiFilter,
  type RangeFilter,
  type SegmentedFilter,
} from '../types/filters';

export const multiInflowDefinition: FilterDefinition<
  MultiFilter<SegmentedFilter<RangeFilter>>
> = {
  id: FilterId.MULTI_INFLOW,
  name: 'Inflow',
  type: FilterType.MULTI,
  wrappedFilterId: FilterId.INFLOW,
  instances: [],
  isVisible: true,
};

export const multiInflowHandler: FilterHandler<
  MultiFilter<SegmentedFilter<RangeFilter>>
> = {
  isActive(currentFilterState) {
    return currentFilterState.instances.length > 0;
  },
  isDefault(currentFilterState) {
    return currentFilterState.instances.length === 0;
  },
  getEffectiveFilter(currentFilterState) {
    return currentFilterState;
  },
};
